import type { AccountProviderType } from 'owa-accounts-store';
import { getOwaResourceImageUrl } from 'owa-resource-url';

export default function getAccountProviderTypeIcon(type: AccountProviderType): string {
    switch (type) {
        case 'Outlook':
            return getOwaResourceImageUrl('Outlook.svg');
        case 'Google':
            return getOwaResourceImageUrl('Google.svg');
        case 'ICloud':
            return getOwaResourceImageUrl('ICloud.svg');
        case 'Yahoo':
            return getOwaResourceImageUrl('Yahoo.svg');
        default:
            return null;
    }
}
